import { useTranslations } from "use-intl";
import { ErrorPageShell } from "./error-page-shell";
import { ErrorContent } from "./error-content";

interface ServerErrorPageProps {
  /** The caught error — stack only shown in import.meta.env.DEV */
  error?: Error;
}

export function ServerErrorPage({ error }: ServerErrorPageProps) {
  const t = useTranslations();

  return (
    <ErrorPageShell page="500">
      <ErrorContent
        code={t("errors.500.code")}
        title={t("errors.500.title")}
        description={t("errors.500.desc")}
        devStack={error?.stack}
      />
    </ErrorPageShell>
  );
}
